import React, { useEffect, useState } from 'react';
import Head from "next/head";

const MapSrc = ({map_type}) => {
	const [fullscreenJs, setFullscreenJs] = useState('');

	useEffect(() => {
		setTimeout(() => {
			setFullscreenJs(<script src='/_vendor/map/Control.FullScreen.min.js'></script>);
		}, 600);
	}, []);

    return (
        <Head>
            <link rel="stylesheet" type="text/css" href={'/_vendor/map/' + ((typeof map_type !== "undefined" && map_type === 'neshan') ? 'neshan' : 'leaflet') + '.css'}/>
			<script src={'/_vendor/map/' + ((typeof map_type !== "undefined" && map_type === 'neshan') ? 'neshan' : 'leaflet') + '.js'}></script>
			<link rel="stylesheet" href="/_vendor/map/leaflet.fullscreen.css" />
			{fullscreenJs}
			{/* <script src="https://cdnjs.cloudflare.com/ajax/libs/leaflet.fullscreen/1.6.0/Control.FullScreen.min.js" integrity="sha512-AmR6ebpa6q+35FINPlrJIYOOFeDIw5B+rcrMnBjZpMl1mehG/R7jVYPJpxFNc5ljk/7af5vAYuRl9mCu9avdDw==" crossorigin="anonymous"></script> */}
        </Head>
    );
};

export default MapSrc;
